module.exports = __webpack_public_path__ + "img/snorkeling2.fdb0ae18.jpeg";